<template>
  <div :class="{radio: true, 'is-checked': checked, 'is-checkmark': checkmark}">
    <input
      type="radio"
      v-model="currentValue"
      :value="bit"
      :disabled="disabled"
      :id="_uid">

    <label class="r" :for="_uid" v-if="!checkmark">
      <sprite name="radio" ref="icon">
        <circle class="icon inner" cx="10" cy="10" :r="radius"/>
      </sprite>
    </label>

    <label class="label" :for="_uid">{{label}}</label>

    <sprite name="done" v-if="checked && checkmark"/>
  </div>
</template>

<script>
  import Sprite from '../Sprite.vue'
  import input from '../../../mixins/input'
  import TWEEN from '@tweenjs/tween.js'

  export default {
    name: 'Radio',

    mixins: [input],

    props: {
      name: String,
      label: String,
      bit: String,
      checkmark: Boolean,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        radius: 0.0
      }
    },

    components: {
      Sprite
    },

    computed: {
      checked() {
        return this.value === this.bit
      },

      desiredRadius() {
        return this.checked ? 4 : 0
      }
    },
    mounted() {
      this.radius = this.desiredRadius
    },

    watch: {
      desiredRadius(newValue, oldValue) {
        let animate = () => {
          if (TWEEN.update()) {
            requestAnimationFrame(animate)
          }
        }

        new TWEEN.Tween({radius: oldValue})
          .to({radius: newValue}, 200)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(({radius}) => this.radius = radius.toFixed(0))
          .start()

        animate()
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .radio
    position: relative
    display: inline-block
    display: flex
    flex-direction: columns
    align-items: center
    padding-right: 30px
    margin-bottom: 10px

    .inner
      fill: $color-primary

    &.is-checked
      .sprite
        fill: $color-primary

      label
        color: $color-text

      &.is-checkmark
        label
          color: $color-primary

    &.is-checkmark
      justify-content: space-between
      height: 30px
      margin-bottom: 0px
      padding-right: 5px

      .sprite
        position: relative

    .is-invalid &
      .sprite, .inner
        fill: $color-error

    .disabled &
      .sprite, .inner
        fill: $color-grey-lighter

    label
      cursor: pointer
      color: $color-text-light

    .r
      position: relative
      width: 19px
      height: 19px
      display: inline-block

    .sprite
      width: 20px
      height: 20px
      position: absolute
      fill: $color-text-light

    input[type="radio"]
      display: none

    .label
      padding-left: 10px

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/Radio.vue